import React from 'react';
import classnames from 'classnames';
import {kebabCase} from 'lodash';
import Icon from 'shared/components/icon';
import Tooltip from 'src/components/tooltip';
import 'stylesheets/components/shared-follow-button.scss';

interface Props {
  following: boolean;
  // Outline button style
  outline?: boolean;
  // Small version of follow button that is 80px wide and
  // collapses into just an icon when following=true. When
  // false, button takes up full width of parent element
  compact?: boolean;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  collegeName?: string;
  // Identifying string for segment tracking
  track?: string;
  className?: string;
}

const FollowButton = ({
  outline,
  following,
  compact,
  onClick,
  collegeName,
  track,
  className,
}: Props) => {
  const buttonName = [following ? 'unfollow' : 'follow'];

  if (track) buttonName.push(kebabCase(track));
  if (collegeName) buttonName.push(kebabCase(collegeName));

  const button = (
    <button
      onClick={onClick}
      className={classnames('shared-follow-button', {outline}, {compact}, {following}, className)}
      aria-label={
        following
          ? `Following ${collegeName || ''}, click to unfollow`
          : `Follow ${collegeName || ''}`
      }
      data-segment-track="button"
      data-button-name={buttonName.join('-')}
      data-testid="button"
    >
      {following ? (
        <>
          <span className="shared-follow-button-following-text" data-testid="following"></span>
          <Icon iconType="check" className="shared-follow-button-icon-check" />
          <Icon iconType="times-r" className="shared-follow-button-icon-x" />
        </>
      ) : (
        'Follow'
      )}
    </button>
  );

  if (compact && following) {
    return <Tooltip title="Unfollow">{button}</Tooltip>;
  } else {
    return button;
  }
};

export default FollowButton;
